var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchangeTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#1E2B45",
    fillOpacity: 0.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1354 19.855L11.3554 22.645C11.1654 22.845 11.1654 23.155 11.3554 23.355L14.1354 26.145C14.4454 26.465 14.9854 26.235 14.9854 25.795V23.995H20.9954C21.5454 23.995 21.9954 23.545 21.9954 22.995C21.9954 22.445 21.5454 21.995 20.9954 21.995H14.9854V20.205C14.9854 19.755 14.4454 19.535 14.1354 19.855ZM28.6454 16.645L25.8654 13.855C25.5554 13.535 25.0154 13.765 25.0154 14.205V15.995H18.9954C18.4454 15.995 17.9954 16.445 17.9954 16.995C17.9954 17.545 18.4454 17.995 18.9954 17.995H25.0054V19.785C25.0054 20.235 25.5454 20.455 25.8554 20.135L28.6354 17.345C28.8354 17.155 28.8354 16.835 28.6454 16.645Z",
    fill: "#F9FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeTransaction);
export default __webpack_public_path__ + "static/media/exchangeTransaction.fd84365af99c3973fa2ce32d0465508e.svg";
export { ForwardRef as ReactComponent };